// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputPanel__container-f3ae91 {
  display: flex;
  padding: 12px 8px;
  justify-content: center;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}

.InputPanel__top-panel-b728dd {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: solid 1px var(--base-20);
  padding: 7px 12px;
  box-sizing: border-box;
  background-color: var(--base-0);
}

.InputPanel__view-fe3df9 {
  display: flex;
  align-items: center;
  max-width: var(--max-width-input-top-panel);
  width: 100%;
  box-sizing: border-box;
  min-width: var(--message-bubble-min-width);
  background-color: var(--base-17);
  border-radius: 24px;
  min-height: 48px;
  margin: 0 8px;
}

.InputPanel__append-a94811 {
  display: flex;
  align-items: center;
  margin: 4px 0 4px 8px;
  align-self: end;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/InputPanel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,iBAAA;EACA,sBAAA;EACA,+BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,WAAA;EAEA,sBAAA;EACA,0CAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAAF","sourcesContent":[".container {\n  display: flex;\n  padding: 12px 8px;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.top-panel {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-top: solid 1px var(--base-20);\n  padding: 7px 12px;\n  box-sizing: border-box;\n  background-color: var(--base-0);\n}\n\n.view {\n  display: flex;\n  align-items: center;\n  max-width: var(--max-width-input-top-panel);\n  width: 100%;\n\n  box-sizing: border-box;\n  min-width: var(--message-bubble-min-width);\n  background-color: var(--base-17);\n  border-radius: 24px;\n  min-height: 48px;\n  margin: 0 8px;\n}\n\n.append {\n  display: flex;\n  align-items: center;\n  margin: 4px 0 4px 8px;\n  align-self: end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `InputPanel__container-f3ae91`,
	"top-panel": `InputPanel__top-panel-b728dd`,
	"topPanel": `InputPanel__top-panel-b728dd`,
	"view": `InputPanel__view-fe3df9`,
	"append": `InputPanel__append-a94811`
};
module.exports = ___CSS_LOADER_EXPORT___;
